import { MdDelete, MdEdit, MdPostAdd } from "react-icons/md";
import { useLanguageContext } from "../../Context/LanguageContext";

const ViewRole = (props) => {
  const {
    userId,
    userDetails,
    userRoleList,
    costCentreListForUser,
    editRoleFuntionCallback,
    addCostCentreFuntionCallback,
    editCostCentreFunctionCallback,
    closeViewRolePopUpCallback,
    deleteRoleCallback,
    deleteCostCentreCallback,
  } = props;
  const { localization } = useLanguageContext();

  function RenderDeleteButtonForRole(props) {
    const id = props.userRoleId;
    return (
      <MdDelete
        id="deleteRoleTest"
        className="mr-4 cursorPoint svgIcon"
        title={localization.deleteRole}
        size={20}
        onClick={() => {
          deleteRoleCallback(id, userDetails);
        }}
      />
    );
  }

  function RenderDeleteButtonForCostCentre(props) {
    const roleId = props.userRoleId;
    const costCentreId = props.costCentreId;
    return (
      <MdDelete
        className="mr-4 cursorPoint svgIcon"
        title={localization.deleteRoleCostCenter}
        size={20}
        onClick={() => {
          deleteCostCentreCallback(roleId, costCentreId, userDetails);
        }}
      />
    );
  }

  function RenderAddCostCentreButton(props) {
    const addCostCentreDetails = props.addCostCentreDetails;
    return (
      <MdPostAdd
        className="mr-4 cursorPoint svgIcon"
        title={localization.addCostCenterForRole}
        size={20}
        onClick={() => {
          addCostCentreFuntionCallback(addCostCentreDetails);
        }}
        data-toggle="modal"
        data-target="#addCostCentreForUserModal"
      />
    );
  }

  return (
    <div
      className="modal fade"
      id="viewRoleModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="viewRoleModal"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="custom-modal modal-dialog" role="document">
        <div className="modal-content vrModelWidth">
          <div className="modal-header">
            <h5>
              {userDetails.vorname} {userDetails.nachname}
            </h5>

            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="viewRoleModalClose"
              onClick={closeViewRolePopUpCallback}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body vrBodyHeig">
            <div className="row d-flex">
              <div className="col">
                <h5 className="modal-title">{localization.roles}</h5>
                <div className="table-responsive vrTabHeig">
                  <table className="table align-middle mb-0 table-striped table-hover table-sticky">
                    <thead className="bg-light">
                      <tr>
                        <th>{localization.role}</th>
                        <th>{localization.plant}</th>
                        <th>{localization.equipmentGrp}</th>
                        <th>{localization.action}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userRoleList.length == 0 ? (
                        <tr>
                          <td colSpan={4}>
                            <p className="text-center">
                              {localization.noRolesAdded}
                            </p>
                          </td>
                        </tr>
                      ) : (
                        userRoleList.map((row, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <p className="fw-bold mb-1">
                                  {row.role == "Super_Admin"
                                    ? localization.organizationAdmin
                                    : row.role}
                                </p>
                              </td>
                              <td>
                                <p className="fw-bold mb-1">{row.plantId}</p>
                              </td>
                              <td>
                                <p className="fw-bold mb-1">
                                  {row.anlagegruppe}
                                </p>
                              </td>
                              <td>
                                <RenderDeleteButtonForRole
                                  userRoleId={row.id}
                                />
                                {row.role != "Super_Admin" ? (
                                  <RenderAddCostCentreButton
                                    addCostCentreDetails={row}
                                  />
                                ) : (
                                  <></>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* Table for cost centre */}
              <div className="col">
                <h5 className="modal-title">{localization.costCenter}</h5>
                <div className="table-responsive vrTabHeig">
                  <table className="table align-middle mb-0 table-striped table-hover table-sticky">
                    <thead className="bg-light">
                      <tr>
                        <th>{localization.role}</th>
                        <th>{localization.equipmentGrp}</th>
                        <th>{localization.costCenter}</th>
                        <th>{localization.action}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {costCentreListForUser.length == 0 ? (
                        <tr>
                          <td colSpan={100}>
                            <p className="text-center">
                              {localization.noCostCenterAdded}
                            </p>
                          </td>
                        </tr>
                      ) : (
                        costCentreListForUser.map((row, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <p className="fw-bold mb-1">{row.role}</p>
                              </td>
                              <td>
                                <p className="fw-bold mb-1">
                                  {row.anlagegruppe}
                                </p>
                              </td>
                              <td>
                                <p className="fw-bold mb-1">
                                  {row.kostenstelle}
                                </p>
                              </td>
                              <td>
                                <RenderDeleteButtonForCostCentre
                                  userRoleId={row.userRoleID}
                                  costCentreId={row.id}
                                />
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewRole;
